export default __webpack_public_path__ + "static/media/research.ca8677bd.svg";